import { PageHeader } from '@/components/layout/page-header';
import { DangerZone } from '@/features/exchange/danger-zone';
import { MaintenanceAllowlistSection } from '@/features/exchange/maintenance-allowlist-section';
import { MaintenanceStatePanel } from '@/features/exchange/maintenance-state-panel';

// /devops/exchange, read top to bottom in the order it is used: is the exchange taking traffic
// (and the one switch that changes that), who is let back in during maintenance, then the
// collapsed Danger Zone holding freeze and the killswitch. One column at a readable width.
const ExchangePage = () => {
  return (
    <div className="flex w-full max-w-5xl flex-col gap-8">
      <PageHeader description="Status, planned maintenance and emergency controls." title="Exchange" />
      <MaintenanceStatePanel />
      <MaintenanceAllowlistSection />
      <DangerZone />
    </div>
  );
};
ExchangePage.displayName = 'ExchangePage';

export default ExchangePage;
